import * as React from 'react';
import styles from './index.less';
import FCoverImage from '@/components/FCoverImage';
import FComponentsLib from '@freelog/components-lib';
import FResourceCard from '@/components/FResourceCard';
import { FI18n, FUtil } from '@freelog/tools-lib';
import { Popover } from 'antd';
import { CustomTitleInput, OverflowTooltip } from '../CollectionList';
import FTooltip from '@/components/FTooltip';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import FCheckbox from '@/components/FCheckbox';
import FIcons from '@/components/FIcons';
// import { FDndContainer, FDndItem, getNewList } from '@/components/FDndContainer';
import * as AHooks from 'ahooks';
// import { ReactSortable } from 'react-sortablejs';
import Sortable from 'sortablejs';
import FReactSortable from '@/components/FReactSortable';

interface CollectionCardsProps {
  resources: {
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    itemNumber: string;
    resourceInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      version: string;
      policy: string[];
      type: string[];
      status: 0 | 1 | 2 | 4;
      authProblem: boolean;
      updateDate: string;
      username: string;
      useAvatar: string;
      isChoice: boolean;
      intro: string;
      releaseDateTime?: string;
    };
  }[];

  showCheckbox: 'show' | 'hide';
  checkedItemIDs: string[];
  showTitle: 'title' | 'serial' | 'custom' | 'customNotEdited' | 'hide';
  showNumber: 'show' | 'hide';
  showCover: 'show' | 'hide';
  showIntroduction: 'show' | 'hide';
  size?: 'normal' | 'small';

  draggable?: boolean;

  onChangeChecked?(itemsID: string, checked: boolean): void;

  onChangeCustomTitle?(itemID: string, title: string): void;

  onClickDelete?(itemID: string): void;

  onClick?(itemID: string, resourceID: string): void;

  onChangeIndex?(itemID: string, index: number, newList: CollectionCardsProps['resources']): void;
}

interface CollectionCardsStates {
  resource: {
    id: string;
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    itemNumber: string;
    resourceInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      version: string;
      policy: string[];
      type: string[];
      status: 0 | 1 | 2 | 4;
      authProblem: boolean;
      updateDate: string;
      username: string;
      useAvatar: string;
      isChoice: boolean;
      intro: string;
      releaseDateTime?: string;
    };
  }[];
}

function CollectionCards({
  resources,
  size = 'normal',
  onChangeCustomTitle,
  onClickDelete,
  onClick,
  showCheckbox,
  checkedItemIDs,
  showCover,
  showIntroduction,
  draggable,
  showNumber,
  showTitle,
  onChangeChecked,
  onChangeIndex,
}: CollectionCardsProps) {
  // const ref_sortable = React.useRef<HTMLDivElement>(null);

  const [$introTooltipOpen, set$introTooltipOpen, get$introTooltipOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$customTitleMouseEnter, set$customTitleMouseEnter, get$customTitleMouseEnter] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$resourceCardOpen, set$resourceCardOpen, get$resourceCardOpen] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$resource, set$resource, get$resource] = FUtil.Hook.useGetState<
    CollectionCardsStates['resource']
  >(
    resources.map((r) => {
      return {
        id: r.itemID,
        ...r,
      };
    }),
  );

  // AHooks.useMount(() => {
  //   const el = ref_sortable.current!;
  //   const sortable = new Sortable(el, {
  //     handle: '.' + styles.dragHandle,
  //     forceAutoScrollFallback: true,
  //     disabled: !draggable,
  //     onEnd: (evt) => {
  //       const resource: CollectionCardsStates['resource'] = get$resource();
  //       const newIndex: number = evt.newDraggableIndex ?? -1;
  //       const oldIndex: number = evt.oldDraggableIndex ?? -1;
  //       const id: string = resource[oldIndex]?.id || '';
  //       const newList = resource.map(({ id, ...r }) => {
  //         return r;
  //       });
  //       onChangeIndex?.(id, newIndex, newList);
  //       // console.log(evt, 'evt 8093ueijorwf;sdkljals;kdjflk;jkl');
  //     },
  //   });
  // });

  AHooks.useDebounceEffect(
    () => {
      set$resource(
        resources.map((r) => {
          return {
            id: r.itemID,
            ...r,
          };
        }),
      );
    },
    [resources],
    {
      wait: 100,
    },
  );

  return (
    <>
      <FReactSortable
        className={styles.CollectionCards}
        style={{
          gap: size === 'small' ? 10 : 20,
          width: size === 'small' ? 635 : 880,
        }}
        // list={$resource}
        // setList={(newState, sortable, store) => {
        //   set$resource(newState);
        // }}
        // handle={'.' + styles.dragHandle}
        // forceAutoScrollFallback={true}
        // disabled={!draggable}
        // onEnd={(evt) => {
        //   // console.log(evt, 'isodjflksdklflsjdfjls;dfj');
        //   const resource: CollectionCardsStates['resource'] = get$resource();
        //   const index: number = evt.newDraggableIndex ?? -1;
        //   const id: string = resource[index]?.id || '';
        //   const newList = resource.map(({ id, ...r }) => {
        //     return r;
        //   });
        //   // console.log(id, index, newList, '89ewijf;klsdjflkjdskljfk;lsjdklfjlksdjflksdjlkj');
        //   onChangeIndex?.(id, index, newList);
        // }}
        options={{
          handle: '.' + styles.dragHandle,
          forceAutoScrollFallback: true,
          disabled: !draggable,
          onEnd: (evt) => {
            const resource: CollectionCardsStates['resource'] = get$resource();
            const newIndex: number = evt.newDraggableIndex ?? -1;
            const oldIndex: number = evt.oldDraggableIndex ?? -1;
            const id: string = resource[oldIndex]?.id || '';
            const newList = resource.map(({ id, ...r }) => {
              return r;
            });
            onChangeIndex?.(id, newIndex, newList);
            // console.log(evt, 'evt 8093ueijorwf;sdkljals;kdjflk;jkl');
          },
        }}
      >
        {$resource.map((i, j) => {
          return (
            <div
              key={i.itemID}
              style={{
                width: size === 'small' ? 205 : 280,
                height: 'fit-content',
                display: 'block',
              }}
              title={
                !onClick || $introTooltipOpen || $customTitleMouseEnter || $resourceCardOpen
                  ? undefined
                  : FI18n.i18nNext.tAuto('cqr_itemmgmt_entry_tooltips')
              }
            >
              {showCheckbox !== 'hide' && (
                <>
                  <div>
                    <FCheckbox
                      checked={checkedItemIDs.includes(i.itemID)}
                      onChange={(e) => {
                        onChangeChecked?.(i.itemID, e.target.checked);
                      }}
                    />
                  </div>
                  <div style={{ height: 10 }} />
                </>
              )}

              <div
                className={styles.card}
                style={{
                  opacity: i.resourceInfo.status === 2 ? 0.4 : 1,
                  flexBasis: size === 'small' ? 205 : 280,
                  cursor: onClick ? 'pointer' : 'auto',
                }}
                onClick={() => {
                  onClick?.(i.itemID, i.resourceInfo.id);
                }}
              >
                {
                  // setting.collection_item_image_display === 'collection_item_image_display_show'
                  showCover === 'show' && (
                    <div
                      style={{
                        width: 'fit-content',
                        height: 'fit-content',
                        position: 'relative',
                      }}
                    >
                      <FCoverImage
                        src={i.resourceInfo.cover}
                        width={size === 'small' ? 185 : 260}
                      />

                      {i.resourceInfo.isChoice && (
                        <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                          <img
                            src={img_choiceLabel}
                            alt={''}
                            style={{
                              width: 16,
                              height: 16,
                              position: 'absolute',
                              top: 4,
                              left: 4,
                            }}
                          />
                        </FTooltip>
                      )}
                    </div>
                  )
                }

                {(showTitle === 'title' ||
                  showTitle === 'custom' ||
                  showTitle === 'customNotEdited' ||
                  showIntroduction === 'show') && (
                  <div className={styles.TitleAndBrief}>
                    {showTitle === 'title' && (
                      <OverflowTooltip
                        text={i.resourceInfo.title || i.resourceInfo.name.split('/')[1]}
                        className={styles.title}
                      />
                    )}

                    {showTitle === 'serial' && (
                      <OverflowTooltip
                        text={i.itemNumber || '(无编号)'}
                        className={styles.title}
                        style={{ opacity: i.itemNumber ? 1 : 0.2 }}
                      />
                    )}

                    {showTitle === 'custom' && (
                      <>
                        {onChangeCustomTitle && (
                          <CustomTitleInput
                            value={i.itemTitle}
                            onChange={(v) => {
                              onChangeCustomTitle(i.itemID, v);
                            }}
                            onMouseEnter={(enter) => {
                              set$customTitleMouseEnter(enter);
                            }}
                          />
                        )}

                        {!onChangeCustomTitle && (
                          <OverflowTooltip
                            text={i.itemTitle}
                            className={styles.title}
                            afterOpenChange={(o) => {
                              // console.log(o, '***************************************');
                              set$introTooltipOpen(o);
                            }}
                          />
                        )}
                      </>
                    )}

                    {showTitle === 'customNotEdited' && (
                      <OverflowTooltip
                        text={i.itemTitle || i.resourceInfo.name.split('/')[1]}
                        className={styles.title}
                      />
                    )}

                    {
                      // setting.collection_item_descr_display === 'collection_item_descr_display_show'
                      showIntroduction === 'show' && (
                        <OverflowTooltip
                          text={i.resourceInfo.intro || FI18n.i18nNext.tAuto('no_short_description')}
                          className={styles.intro}
                          style={{ opacity: i.resourceInfo.intro ? 1 : 0.6 }}
                          afterOpenChange={(o) => {
                            // console.log(o, '***************************************');
                            set$introTooltipOpen(o);
                          }}
                        />
                      )
                    }
                  </div>
                )}

                <div className={styles.info}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.tAuto('cqr_itemmgmt_entry_resourceinfo')}
                    singleRow
                    type={'additional2'}
                    style={{ maxWidth: '100%' }}
                  />

                  <Popover
                    content={
                      <FResourceCard
                        key={i.resourceInfo.id}
                        resource={i.resourceInfo}
                        onClick={(event) => {
                          event.stopPropagation();
                          window.open(
                            FUtil.LinkTo.resourceDetails({
                              resourceID: i.resourceInfo.id,
                            }),
                          );
                        }}
                      />
                    }
                    title={null}
                    placement={'bottom'}
                    overlayClassName={styles.resourceCardPopover}
                    onOpenChange={(o) => {
                      set$resourceCardOpen(o);
                    }}
                  >
                    <div
                      style={{ width: 'fit-content' }}
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    >
                      <FComponentsLib.FTextBtn
                        type='default'
                        onClick={() => {
                          window.open(
                            FUtil.LinkTo.resourceDetails({
                              resourceID: i.resourceInfo.id,
                            }),
                          );
                        }}
                      >
                        <FComponentsLib.FContentText
                          text={i.resourceInfo.title || i.resourceInfo.name.split('/')[1]}
                          type={'additional2'}
                          style={{
                            color: 'inherit',
                            textDecoration: 'underline',
                            maxWidth: size === 'small' ? 185 : 260,
                          }}
                          singleRow
                        />
                      </FComponentsLib.FTextBtn>
                    </div>
                  </Popover>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <FComponentsLib.FContentText
                      text={i.resourceInfo.type.join('/')}
                      type={'additional2'}
                      style={{
                        color: '#666',
                        flexBasis: 'fit-content',
                        flexShrink: 0,
                      }}
                    />
                    <FComponentsLib.FContentText
                      text={'|'}
                      type={'additional2'}
                      style={{
                        color: '#666',
                        flexBasis: 'fit-content',
                        flexShrink: 0,
                      }}
                    />
                    <FComponentsLib.FContentText
                      // text={`更新时间${resourceInfo.updateDate}`}
                      text={FI18n.i18nNext.tAuto('cqr_itemmgmt_entry_lastupdated', {
                        Timestamp: i.resourceInfo.releaseDateTime || i.resourceInfo.updateDate,
                      })}
                      type={'additional2'}
                      style={{
                        color: '#666',
                        flexBasis: 'fit-content',
                        flexShrink: 1,
                      }}
                      singleRow
                    />
                  </div>
                </div>

                {
                  // setting.collection_item_no_display === 'collection_item_no_display_show'
                  (showNumber === 'show' ||
                    i.resourceInfo.authProblem ||
                    i.resourceInfo.status === 2 ||
                    onClickDelete) && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div className={styles.bottom}>
                        {
                          // setting.collection_item_no_display === 'collection_item_no_display_show'
                          showNumber === 'show' && (
                            <FComponentsLib.FContentText
                              text={String(i.itemSerial)}
                              type={'highlight'}
                            />
                          )
                        }

                        {i.resourceInfo.status !== 2 && i.resourceInfo.authProblem && (
                          <FTooltip
                            // title={'存在授权问题'}
                            title={FI18n.i18nNext.tAuto('alert_resource_no_auth')}
                          >
                            <FIcons.FWarning style={{ fontSize: 16 }} />
                          </FTooltip>
                        )}

                        {i.resourceInfo.status === 2 && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              flexBasis: 50,
                              flexShrink: 0,
                              justifyContent: 'flex-end',
                              width: '100%',
                            }}
                          >
                            <FResourceStatusBadge status={'freeze'} />
                          </div>
                        )}
                      </div>

                      {onClickDelete && (
                        <FComponentsLib.FTextBtn
                          type={'danger'}
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickDelete(i.itemID);
                          }}
                          className={styles.Delete}
                        >
                          <FIcons.FDelete />
                        </FComponentsLib.FTextBtn>
                      )}

                      {draggable && (
                        <a className={styles.dragHandle} title={'拖动排序'}>
                          <FIcons.FDrag style={{ color: '#666' }} />
                        </a>
                      )}
                    </div>
                  )
                }
              </div>
            </div>
          );
        })}
      </FReactSortable>
    </>
  );
}

export default CollectionCards;
